import { Grid, Skeleton, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { NumberOfPosition } from './NumberOfPositions';
import { OrderReason } from './OrderReason';
import { OrderType } from './OrderType';
import { OrderTypeSwitchDetails } from './OrderTypeSwitchDetails';
import { Region } from './Region';
import { ExperienceSetWrapper } from './ExperienceSetWrapper';
import { usePromiseTracker } from 'react-promise-tracker';
import PositionFileOutReason from './PositionFileOutReason';

const OrderRequirements = () => {
  const { t } = useTranslation();
  const { promiseInProgress: fetchingOrderTypeList } = usePromiseTracker({ area: 'order-types', delay: 0 });
  const { promiseInProgress: fetchingOrderRegions } = usePromiseTracker({ area: 'order-regions', delay: 0 });

  return (
    <>
      {/* First Container */}
      <Grid container sx={{ mt: '0px', pl: '10px' }}>
        <Grid xs={12} sx={{ paddingBottom: '7px' }}>
          <Typography variant="h6" fontWeight={'normal'}>
            {t('order.newOrderCreation.tabs.orderRequirements')}
          </Typography>
        </Grid>
        <Grid sx={{ flex: '1 1 auto', display: 'flex', flexDirection: 'column' }}>
          <Grid
            sx={{
              backgroundColor: theme => theme.palette.system.skyBlue,
              border: theme => `1px solid ${theme.palette.system.lightGrey}`,
              borderRadius: '4px 4px 0px 0px',
              padding: '9px 12px',
            }}
            xs={12}
          >
            <Typography fontWeight={'bold'} fontSize={'16px'} variant="body1">
              {t('order.newOrderCreation.tabs.orderTypeDetails')}
            </Typography>
          </Grid>
          <Grid
            sx={{
              border: theme => `1px solid ${theme.palette.system.lightGrey}`,
              borderRadius: '0px 0px 4px 4px',
              flexGrow: 1,
            }}
          >
            <Grid container spacing={2} sx={{ padding: '12px 12px 8px 12px' }} justifyContent={'center'}>
              {/* First Column */}
              <Grid item xs={6}>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    {fetchingOrderTypeList ? <Skeleton height={45} /> : <OrderType />}
                  </Grid>
                  <Grid item xs={6}>
                    {fetchingOrderTypeList ? <Skeleton height={45} /> : <OrderReason />}
                  </Grid>
                  <Grid item xs={6}>
                    {fetchingOrderRegions ? <Skeleton height={45} /> : <Region />}
                  </Grid>
                  <Grid item xs={6}>
                    {fetchingOrderTypeList ? <Skeleton height={45} /> : <NumberOfPosition />}
                  </Grid>
                </Grid>
              </Grid>

              {/* Second Column */}
              <Grid item xs={6}>
                <Grid container sx={{ marginLeft: '24px' }}>
                  <Grid item>
                    <OrderTypeSwitchDetails />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={4.9} sx={{ marginRight: '138px' }}>
                {fetchingOrderTypeList ? <Skeleton height={45} /> : <PositionFileOutReason />}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      {/* Second Container */}
      <Grid container sx={{ mt: '24px', pl: '10px', pb: '20px' }} xs={12}>
        <ExperienceSetWrapper />
      </Grid>
    </>
  );
};
export default React.memo(OrderRequirements);
